<template>
    <div style="height: 100%;" :style="{ 'background-color': $vuetify.theme.themes.light.backgroundHome }">
      <Pendencia style="height: 100%;"/>
    </div>
</template>

<script>
import Pendencia from '../components/Pendencia/Pendencia'

export default {
  components: {
    Pendencia
  },
  beforeMount () {
    this.$emit('loadDados')
  }
}
</script>
